<template>
  <div class="container-fluid">
    <BarreActions :actions="actions" @appliquer-action="executerAction($event)" />
    
    <!--input pour sélectionner un Logo-->
    <input type="file" accept=".png" @change="chargerNouveauLogo($event)" style="display: none" ref="importLogo" />
    <!--input pour sélectionner une Banniere-->
    <input type="file" accept=".png" @change="chargerNouvelleBanniere($event)" style="display: none" ref="importBanniere" />


    <div class="row" v-if="infosFournisseur" >
      <div class="col-6">
        <div class="card">
          <div class="card-header">
            Coordonnées
          </div>
          <div class="card-body m2">
            <div class="row">
              <span class="col-12">
                <div><b><label for="InputRaisonSociale">Raison Sociale</label></b></div>
                <input id="InputRaisonSociale" type="text" v-model="infosFournisseur.nom" style="width: 100%;">
              </span>  
            </div>
            <br/>
            <div class="row">
              <span class="col-12">
                <div><b><label for="InputLien">Lien Site Internet</label></b></div>
                <input id="InputLien" type="text" v-model="infosFournisseur.lienWeb" style="width: 100%;">
              </span>  
            </div>
            <br/>
            <div class="row">
              <span class="col-12">
                <div><b><label for="InputAdresseUn">Adresse</label></b></div>
                <input id="InputAdresseUn" type="text" v-model="infosFournisseur.adresse1" style="width: 100%;">
                <input id="InputAdresseDeux" type="text" v-model="infosFournisseur.adresse2" style="width: 100%;" placeholder="Complément Adresse 1">
                <input id="InputAdresseTrois" type="text" v-model="infosFournisseur.adresse3" style="width: 100%;" placeholder="Complément Adresse 2">
              </span>  
            </div>
            <br/>
            <div class="row">
              <span class="col-4">
                <div><b><label for="InputCodePostal">Code Postal</label></b></div>
                <input id="InputCodePostal"  type="text" v-model="infosFournisseur.codePostal" style="width: 100%;">
              </span>  
              <span class="col-4">
                <div><b><label for="InputVille">Commune</label></b></div>
                <input id="InputVille" type="text" v-model="infosFournisseur.commune" style="width: 100%;">
              </span>                
              <span class="col-4">
                <div><b><label for="InputSiret">Siret</label></b></div>
                <input id="InputSiret" type="text" v-model="infosFournisseur.siret" style="width: 100%;">
              </span>                              
            </div>
            <br/>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="card">
          <div class="card-header">
            Logo
          </div>
          <div class="card-body m2">
            <div class="row">
              <div class="col-6 flex-center-center">
                  <span>
                    <div><b><label class="flex-center-center">Logo Actuel</label></b></div>
                    <img id="ImgLogo" :src="urlLogo.actuel" alt="" style="max-width: 200px; max-height: 100px;">
                  </span>
              </div>
              <div class="col-6">
                <div class="flex-center-center">  
                  <span>
                    <div><b><label v-if="urlLogo.aValider" class="flex-center-center">Logo en attente de validation</label></b></div>
                    <img id="ImgLogo" v-if="urlLogo.aValider" :src="urlLogo.aValider" alt="" style="max-width: 200px; max-height: 100px;">
                  </span>
                </div>
                <br/>
                <div class="flex-center-center">  
                  <span>
                    <button class="btn btn-primary" :title="'Importer un logo'" @click="importerNouveauLogo()" >Sélectionner un Logo</button>
                  </span>
                </div>
              </div>
            </div>
            <br/>
            <div class="flex-center-center">
              Image au format png, taille recommandée : hauteur 100px, largeur 200px
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            Bannière
          </div>
          <div class="card-body m2">
            <div class="flex-center-center">
              <span>
                <div><b><label class="flex-center-center">Bannière Actuelle</label></b></div>
                <img id="ImgBanniere" :src="urlBanniere.actuelle" alt="" style="width: 100%; max-width: 1000px; max-height: 200px;">
              </span>
            </div>
            <div v-if="urlBanniere.aValider" class="flex-center-center">
              <span>
                <div><b><label class="flex-center-center">Bannière en attente de validation</label></b></div>
                <img id="ImgBanniereAValider" :src="urlBanniere.aValider" alt="" style="width: 100%; max-width: 1000px; max-height: 200px;">
              </span>
            </div>
            <div class="flex-center-center">
              <span>
                <button class="btn btn-primary" :title="'Importer une bannière'" @click="importerNouvelleBanniere()" >Sélectionner une bannière</button>
              </span>
            </div>
            <br/>
            <div class="flex-center-center">
              Image au format png, taille recommandée : hauteur 200px, largeur 1000px
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--
    <div class="card card-body">
      <h4>Mon profil</h4>
      <br/>
       => Page redirigée vers l'ancien espace fournisseur
    </div>
    -->
    <!--Card cachée pour gérer le formulaire de connexion à l'ancien espace fournisseur-->
    <!--
    <div hidden class="card card-body">
      <form name="formLogin" method="post" :action="adresseMonCompte()">
        <input type="text" name="Login"/>
        <input type="text" name="Password" />
        <input type="checkbox" name="RememberMe" />
       </form>
    </div>
    -->

  </div>
</template>
<script>
import { connecteData } from "@/mixins/connecteData"
import { alerteDonneesModifiees } from "@/mixins/index"
import { obtenirInfosFournisseurAdresse, obtenirLogoFournisseur, obtenirBanniereFournisseur, modifierInfosFournisseur, importerLogoBanniereFournisseur } from '@/api/gpao/user'
import BarreActions from '@/components/Divers/BarreActions'
import { arrondiMercuriale } from '../helpers/utils'
import _ from 'lodash'


export default {
  name: "profil",
  mixins: [ connecteData, alerteDonneesModifiees ],
  components: { BarreActions },
  data() {
    return {
      contenuPage: "",
      urlLogo: {},
      urlBanniere: {},
      infosFournisseur: {},
      donneesInitialesFournisseur: {},
      urlLogoInitial: {},
      urlBanniereInitial: {},
      formData: null,
      actions: {
        // Boutons à afficher dans la barre d'action
        // Exemple :
        /*
        nomAction: {
          label: Label affiché sur le bouton (string),
          disabled: Etat actif/inactif par défaut du bouton (bool),
          class: Classe CSS (btn-primary, btn-success, btn-warning ou btn-danger) à appliquer sur le bouton (par défaut : "btn-primary" est appliqué => il s'agit du bouton bleu Agap'pro) (string)
          methode(contexte) {
            // => contexte équivaut à this (mais this ne fonctionne pas car l'initialisation de data n'est pas encore terminée, donc data n'est pas encore rattaché à this)
            traitements à exécuter lors du clic sur le bouton
            les traitements définis dans cette page doivent être appelés sous la forme : contexte.traitement()

            Remarque : pour que le système fonctionne, il faut déclarer la méthode ci-dessous dans la section "methods" de cette page
            executerAction(methode) {
              methode(this)
            }

          }
        }
        */
        annuler: {
          label: "Annuler",
          disabled: true,
          class: "btn-danger",
          methode(contexte) {
            contexte.infosFournisseur = _.cloneDeep(contexte.donneesInitialesFournisseur) 
            contexte.urlLogo = _.cloneDeep(contexte.urlLogoInitial) 
            contexte.urlBanniere = _.cloneDeep(contexte.urlBanniereInitial) 
            contexte.formData = new FormData()
          }
        },
        enregistrer: {
          label: "Enregistrer",
          disabled: true,
          class: "btn-success",
          methode(contexte) {
            contexte.enregistrerModification()  
          }
        },
        // Appeler "this.actions.initialiser(this)"" dans mounted() => génère les tableaux d'actions utilisés pour afficher les boutons à gauche et à droite de la barre d'actions
        barreGauche: [],
        barreDroite: [],
        initialiser(contexte) {
          contexte.actions.barreGauche = [ ]
          contexte.actions.barreDroite = [ contexte.actions.annuler, contexte.actions.enregistrer ]
        },
        // A gérer en cas de boutons à activer/désactiver (créer une méthode par groupe de boutons à activer/désactiver)
        disable(actions, disabled) {
          let actionsATraiter = [ actions.annuler, actions.enregistrer ]
          actionsATraiter.forEach(a => a.disabled = disabled)
        }
      }
    }
  },
  
  computed: {
    donneesModifiees() {
      return (this.donneesInitialesFournisseur && this.infosFournisseur && !_.isEqual(JSON.stringify(this.donneesInitialesFournisseur), JSON.stringify(this.infosFournisseur))) || 
             (this.urlLogoInitial && this.urlLogo && !_.isEqual(JSON.stringify(this.urlLogoInitial), JSON.stringify(this.urlLogo))) ||
             (this.urlBanniereInitial && this.urlBanniere && !_.isEqual(JSON.stringify(this.urlBanniereInitial), JSON.stringify(this.urlBanniere)))
    },
    logoBanniereAEnvoyer() {
      return (this.urlLogoInitial && this.urlLogo && !_.isEqual(JSON.stringify(this.urlLogoInitial), JSON.stringify(this.urlLogo))) ||
             (this.urlBanniereInitial && this.urlBanniere && !_.isEqual(JSON.stringify(this.urlBanniereInitial), JSON.stringify(this.urlBanniere)))
    }
  },
  watch: {
    donneesModifiees() {
      if (this.donneesModifiees) {
        this.actions.disable(this.actions, false)
      } else {
        this.actions.disable(this.actions, true)
      }
    }
  },
  validations: {
    
  },
  methods: {
    executerAction(methode) {
      // Nécessaire pour faire fonctionner les actions de la barre d'actions'
      methode(this)
    },
    adresseMonCompte() {
      let adr = process.env.VUE_APP_BASE_BO
      return adr + "/Fournisseurs/Account/LoginFromAnotherSite?ReturnUrl=%2FFournisseurs%2FMonCompte"
    },
    async chargerDonnees() {
      this.$store.commit('uxHelpers/showSpinner')

      this.urlLogo = {actuel: "", aValider: ""}
      this.urlBanniere = {actuelle: "", aValider: ""}

      let infoFournisseur = await obtenirInfosFournisseurAdresse(this.fournisseurCourantId)
      this.infosFournisseur = infoFournisseur.data

      //On ne peut pas retourner à la fois une structure JSON et des memoryStream, donc pour récupérer le logo et la banniere il faut faire d'autres appel API :-(
      //Le stockage du nouveau référentiel n'est pas publique, donc on ne peut pas juste mettre l'adresse du logo .... 
      //Et on ne peut pas faire d'API qui retournent plusieurs Stream à la fois .... piiuuufffffff, ou alors avec le composant multipart-stream-parser ... qui n'est pas installé, mais sans garantie que ça fonctionne bien aussi ....

      let ret = await obtenirLogoFournisseur(this.fournisseurCourantId, false)
      if (ret && ret.data && ret.data.size > 0) {
        let blob = new Blob([ret.data], {type: 'image/png'})
        this.urlLogo.actuel = URL.createObjectURL(blob);
      }

      ret = await obtenirLogoFournisseur(this.fournisseurCourantId, true)
      if (ret && ret.data && ret.data.size > 0) {
        let blob = new Blob([ret.data], {type: 'image/png'})
        this.urlLogo.aValider = URL.createObjectURL(blob);
      }
      
      ret = await obtenirBanniereFournisseur(this.fournisseurCourantId, false)
      if (ret && ret.data && ret.data.size > 0) {
        let blob = new Blob([ret.data], {type: 'image/png'})
        this.urlBanniere.actuelle = URL.createObjectURL(blob);
      }

      ret = await obtenirBanniereFournisseur(this.fournisseurCourantId, true)
      if (ret && ret.data && ret.data.size > 0) {
        let blob = new Blob([ret.data], {type: 'image/png'})
        this.urlBanniere.aValider = URL.createObjectURL(blob);
      }

      this.donneesInitialesFournisseur = _.cloneDeep(this.infosFournisseur)
      this.urlLogoInitial = _.cloneDeep(this.urlLogo)
      this.urlBanniereInitial = _.cloneDeep(this.urlBanniere)

      this.$store.commit('uxHelpers/hideSpinner')
    },
    async enregistrerModification() {
      //On enregistre les infos user et fournisseur en meme temps, via deux API
      await modifierInfosFournisseur(this.infosFournisseur)

      //On envoie les logos et bannieres à valider si besoin
      if (this.logoBanniereAEnvoyer) {
        await importerLogoBanniereFournisseur(this.fournisseurCourantId, this.formData)
      }

      await this.chargerDonnees()

      await this.alerteSucces("Modifications enregistrées")
    },
    importerNouveauLogo() {
      this.selectedFile=null
      //this.formDataLogo=null
      this.$refs.importLogo.click()
    },
    importerNouvelleBanniere() {
      this.selectedFile=null
      //this.formDataBanniere=null
      this.$refs.importBanniere.click()
    },
    chargerNouveauLogo(event) {
      //on récupère le fichier à traiter
      if (event.target.files.length != 0) {
        if (!this.formData)
          this.formData = new FormData();
        else {
          //il faut supprimer l'entrée logo du formData
          this.formData = this.supprimerFichierFormData('logo.png')
        }
        this.selectedFile = event.target.files[0];

        if (this.selectedFile.size > (1024 * 1024 * 10)) {
          // Fichier de 100 Mo maximum
          this.alerteErreur("Le logo que vous tentez d'importer est trop volumineux (" + arrondiMercuriale(this.selectedFile.size / 1024 / 1024) + " Mo). Taille maximale : 10 Mo.")
          return
        }
        this.formData.append('fichiers', this.selectedFile, 'logo.png');

        let blob = new Blob([this.selectedFile], {type: 'image/png'})
        this.urlLogo.aValider = URL.createObjectURL(blob);
      }
    },
    chargerNouvelleBanniere(event) {
      //on récupère le fichier à traiter
      if (event.target.files.length != 0) {
        if (!this.formData)
          this.formData = new FormData();
        else {
          this.formData = this.supprimerFichierFormData('banniere.png')
        }
       
        this.selectedFile = event.target.files[0];

        if (this.selectedFile.size > (1024 * 1024 * 10)) {
          // Fichier de 100 Mo maximum
          this.alerteErreur("La banniere que vous tentez d'importer est trop volumineuse (" + arrondiMercuriale(this.selectedFile.size / 1024 / 1024) + " Mo). Taille maximale : 10 Mo.")
          return
        }

        this.formData.append('fichiers', this.selectedFile, 'banniere.png');

        let blob = new Blob([this.selectedFile], {type: 'image/png'})
        this.urlBanniere.aValider = URL.createObjectURL(blob);
      }
    },
    supprimerFichierFormData(nomFichier) {
        const files = [...this.formData.entries()];
        // reset formData
        let localFormData = new FormData() 
        files.forEach(function (item) {
            // if found
            if (item[1].name !== nomFichier) {
                // make new formData without this item
                localFormData.append('fichiers', item[1], item[1].name)
            }
        });

        return localFormData
    }
  },
  created() {
    // Déclenche un verrou et un message à la fermeture du navigateur si des données sont en cours de modification (Le message est déclenché si la valeur retournée est différente de null)
    window.onbeforeunload = (() => {
      if (this.donneesModifiees)
        return true
      return null
    })
  },
  
  async mounted() {
    this.actions.initialiser(this)
    await this.chargerDonnees()
    


    //this.$store.state.user

    //On réoriente vers la page profil de "l'ancien" espace fournisseur
    //On récupère les infos de connexion dans le cookie MercuSoftLoginFournisseur
    /*
    let cook = getCookie("MercuSoftLoginFournisseur")
    if (cook) {
      document.formLogin["Login"].value=cook.split('&').first().replace('Login=','')
      document.formLogin["Password"].value=cook.split('Password=').last()
      document.formLogin["RememberMe"].checked=true
      document.formLogin["RememberMe"].value="True"
    }
    document.formLogin.target="monCompteBO"
    window.open('', 'monCompteBO');
    document.formLogin.submit();
    */
  }
}
</script>

